import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import useForm, { FormContext } from 'react-hook-form';
import { makeStyles } from '@material-ui/core/styles';
import {
    Box,
    Button,
    Grid,
    Typography
} from '@material-ui/core';
import TextField from '../form/TextField';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    form: {
        width: '100%',
    },
    fieldContainer: {
        marginBottom: theme.spacing(2),
    },
    responsiveGrid: {
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    submitContainer: {
        textAlign: 'center',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
    },
    submitButton: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontSize: '1.6rem',
        padding: theme.spacing(1.5, 4),
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
}));

const MailForm = ({ onSubmit, name, email, title }) => {
    const classes = useStyles();
    const methods = useForm(); // initialise the hook
    const { handleSubmit, setValue } = methods;

    useEffect(() => {
        setValue('name', name);
        setValue('email', email);
        setValue('title', title);
    }, [name, email, title, setValue])

    const submitFormData = data => {
        onSubmit(data);
    }

    return (
        <div className={classes.root}>
            <FormContext {...methods} >
                <form onSubmit={handleSubmit(submitFormData)} className={classes.form}>
                    <Box className={classes.fieldContainer}>
                        <TextField
                            label="件名"
                            type="text"
                            placeholder="件名を入力してください"
                            name="title"
                            registerOptions={{ required: true, maxLength: 100 }}
                        />
                    </Box>

                    <Grid container spacing={2} className={classes.responsiveGrid}>
                        <Grid item xs={12} md={6}>
                            <Box className={classes.fieldContainer}>
                                <TextField
                                    label="送信者名"
                                    type="text"
                                    placeholder="送信者名を入力してください"
                                    name="name"
                                    registerOptions={{ required: true, maxLength: 100 }}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box className={classes.fieldContainer}>
                                <TextField
                                    label="返信用メールアドレス"
                                    type="email"
                                    placeholder="メールアドレスを入力してください"
                                    name="email"
                                    info="広告主が返信する際に利用する為、アドレスに間違いが無いか必ずご確認ください"
                                    registerOptions={{ required: true, maxLength: 100 }}
                                />
                            </Box>
                        </Grid>
                    </Grid>

                    <Box className={classes.fieldContainer}>
                        <TextField
                            label="メッセージ"
                            type="textarea"
                            name="message"
                            rows={15}
                            registerOptions={{ required: true, maxLength: 5000 }}
                        />
                    </Box>

                    <Box className={classes.submitContainer}>
                        <Button
                            type="submit"
                            className={classes.submitButton}
                            variant="contained"
                            size="large"
                        >
                            送信
                        </Button>
                    </Box>
                </form>
            </FormContext>
        </div>
    )
}

MailForm.propTypes = {
    onSubmit: PropTypes.func,
    email: PropTypes.string,
    title: PropTypes.string
}

export default MailForm
